import type { Layout as RichMediaLayout } from '@atlaskit/adf-schema/rich-media-common';

export const nonWrappedLayouts: RichMediaLayout[] = ['center', 'wide', 'full-width'];
